import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { PILL } from '../../interfaces/pill.interface';
import { PillService } from '../../services/pill.service';


@Component({
  selector: 'app-pill',
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.css']
})
export class PillComponent implements OnInit {

  currentPill = 0
  datepipe: DatePipe = new DatePipe('es-ES')

  urlVideoSafe: any;

  pill: PILL = {};

  id_next: number = 0
  id_prev: number = 0

  fecha: string | null = ''

  videoURI: SafeResourceUrl | undefined;

  constructor(
    public pillService: PillService,
    public sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false; // Can reload the page
    this.route.params.subscribe(params => {
      this.currentPill = params['id']
    });
  }

  public safeURL(value: any): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }

  shareOnFacebook(): void {
    const url = window.location.href;

    // Abre una ventana para compartir en Facebook
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      'pop', 'width=600, height=400, scrollbars=no');
  }
  shareOnLinkedin(): void {
    const url = window.location.href;

    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`);
  }


  ngOnInit(): void {
    this.titleService.setTitle('retailCo #Retalk: ' + this.pill.title);

    this.pillService.getPill(this.currentPill).subscribe(
      (resp) => {
        this.pill = resp
        this.fecha = this.pill.date ? this.pill.date : ''
        this.fecha = this.datepipe.transform(this.fecha, 'dd MMMM yyyy')

        if (resp.next) {
          if (resp.next.id != null &&
            resp.next.status === 1 &&
            (!resp.next.datePublishing || resp.next.datePublishing === "" || new Date(resp.next.datePublishing) < new Date())
          ) {
            this.id_next = resp.next.id
          }
        }
        if (resp.prev) {
          if (resp.prev.id != null &&
            resp.prev.status === 1 &&
            (!resp.prev.datePublishing || resp.prev.datePublishing === "" || new Date(resp.prev.datePublishing) < new Date())
          ) { this.id_prev = resp.prev.id }
        }


        this.videoURI = this.safeURL(this.pill.videoUrl)
        this.urlVideoSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.pill.videoUrl!);

        this.titleService.setTitle('retailCo #Retalk Pills: ' + this.pill.title);
      },
      (err) => { }

    );
  }

}
